import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import UpdateSelfPhone from 'components/ReusableComponents/UpdateSelfPhone'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import coreApi from 'services/coreApi'
import { formatPhoneNumber } from 'utils/common'

import AppStoreBadge from './AppStoreBadge'
import styles from './ConnectApp.module.scss'
import GooglePlayBadge from './GooglePlayBadge'

const statusTypes = {
  waiting: 'waiting',
  sending: 'sending',
  sent: 'sent',
  failed: 'failed'
}

const playStoreURL =
  'https://play.google.com/store/apps/details?id=io.swaypay.dash&hl=en&gl=US'

const DownloadApp = () => {
  const userPhone = useSelector(s => s.login.currentUser.phone)

  const [status, setStatus] = useState(statusTypes.waiting)

  const { addToast } = useToasts()

  const { postEvent, plausibleEvents } = usePlausible()

  function sendDownloadLink() {
    postEvent(plausibleEvents.ClickMobileAppDownloadButton)

    coreApi.sendDownloadLink(userPhone).then(data => {
      if (data.ok) {
        setStatus(statusTypes.sent)
        addToast(`We just sent the download link to ${userPhone}!`, {
          appearance: 'success',
          autoDismiss: false
        })
      } else {
        setStatus(statusTypes.failed)
        addToast(`Something went wrong while sending a text to ${userPhone}`, {
          appearance: 'error',
          autoDismiss: false
        })
      }
    })
  }

  if (status === statusTypes.sending) {
    return <LoadingIndicator />
  }

  if (userPhone) {
    return (
      <div className={styles.container}>
        <CustomHeader title="Download Directful App" width={800} />
        <div className={styles.box}>
          <div className={styles.boxTop}></div>
          <div className={styles.boxBottom}>
            <h3 className={styles.title}>Manage guest conversation from your phone</h3>
            <p className={styles.desc}>
              Follow these steps to set up your Directful app:
            </p>
            <div className={styles.instructionsHolder}>
              <p className={styles.instructions}>
                1. Click on the button below to receive the app link
              </p>
              <p className={styles.instructions}>2. Download the app using the link</p>
              <p className={styles.instructions}>
                3. Open the app and enter your phone number:{' '}
                <span className={styles.phoneReminder}>
                  {formatPhoneNumber(userPhone)}
                </span>
              </p>
              <p className={styles.instructions}>
                4. Enter the 4-digit code you receive via text
              </p>
            </div>
            <button onClick={sendDownloadLink} className={styles.loginButton}>
              Get a download link
            </button>
            <div className={styles.storeLinks}>
              <p className={styles.desc}>
                Directful app is available on App Store and Play Store.
              </p>
              <div className={styles.badges}>
                <span>
                  <AppStoreBadge />
                </span>
                <a href={playStoreURL} target="_blank" rel="noreferrer">
                  <GooglePlayBadge />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <CustomHeader title="Download Directful App" width={800} />
      <div className={styles.box}>
        <div className={styles.boxBottom}>
          <h3 className={styles.title}>Add your phone number to use Directful app</h3>
          <p className={styles.desc}>
            Enter your phone number below to receive an SMS with a download link.
          </p>
          <UpdateSelfPhone />
        </div>
      </div>
    </div>
  )
}

export default DownloadApp
